import { Reducers } from '@sda/enums/store';
import { PrivateRequestMask } from '@sda/sdk/masks';
import { SDK } from './helpers/sdk';
import type { FirestoreClientData } from './interfaces';
import type { Request } from '@sda/interfaces/request';

/**
 * SDK Class to interact with Firestore Acts.
 */
export class Requests extends SDK<Request> {
  constructor(apiClient: FirestoreClientData) {
    super(apiClient, Reducers.REQUESTS);

    this.collection = this.fsh.Schema.PrivateRequests;

    this.PrivateMap = PrivateRequestMask;
  }
}
